import MonthCell from "./monthCell";

export default MonthCell;
